import { ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { HomeSubjectService } from '../../container/home-subject.service';
import { Subscription } from 'rxjs';
import { ChatWidgetService } from '@app/shared/services/chat-widget/chat-widget.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'help-button',
  templateUrl: './help-button.component.html',
  styleUrl: './help-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpButtonComponent implements OnDestroy {
  @Input() step: string;
  @Input() isDisabled: boolean = false;

  subscription: Subscription = new Subscription();
  constructor(private homeSubjectService: HomeSubjectService, private chatWidgetService: ChatWidgetService) {}

  openChatBox(event) {
    // if(this.isDisabled) {return;}
    event.stopPropagation();
    this.subscription.add(
      this.chatWidgetService
        .sendQuestionMessage({
          step: this.step,
        })
        .subscribe(() => {})
    );
    this.homeSubjectService.handleFetchChatBoxOpenState(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
